import { render, staticRenderFns } from "./ProductSubgroupSidebar.vue?vue&type=template&id=39fc9256&"
import script from "./ProductSubgroupSidebar.vue?vue&type=script&lang=js&"
export * from "./ProductSubgroupSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39fc9256')) {
      api.createRecord('39fc9256', component.options)
    } else {
      api.reload('39fc9256', component.options)
    }
    module.hot.accept("./ProductSubgroupSidebar.vue?vue&type=template&id=39fc9256&", function () {
      api.rerender('39fc9256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-subgroup/ProductSubgroupSidebar.vue"
export default component.exports